const placeholdersCount = 4; // One more than the actual
const placeholders = document.querySelectorAll('[data-placeholder]');

const replacePlaceholders = () => {
  if (placeholders.length === 0) {
    return;
  }

  const locator = document.querySelectorAll('.js-section-locator');
  const lastNode = locator[locator.length - 1];
  const mainHolder = lastNode.parentElement;
  const lastNodeIndex = Array.prototype.indexOf.call(mainHolder.children, lastNode) + 1;

  const sectionsToRemove = [];
  placeholders.forEach((placeholder, index) => {
    const section = mainHolder.querySelector(
      `.content-for-layout > :nth-child(${lastNodeIndex + index + 1})`
    );
    placeholder.outerHTML = section.outerHTML;
    sectionsToRemove.push(section);
  });
  sectionsToRemove.forEach((section) => {
    section.parentElement.removeChild(section);
  });
};

replacePlaceholders();

const hideMovedSections = () => {
  if (placeholders.length) {
    return;
  }

  const locator = document.querySelector('.js-hide-sections');
  const mainHolder = locator.parentElement;
  const locatorIndex = Array.prototype.indexOf.call(mainHolder.children, locator) + 1;

  for (let i = 0; i <= placeholdersCount; i++) {
    const section = mainHolder.querySelector(
      `.content-for-layout > :nth-child(${locatorIndex + i + 1})`
    );
    section.classList.add('hidden');
  }
};

hideMovedSections();
